/* tslint:disable */
/* eslint-disable */
/**
 * API Docs
 * The API description
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { DeleteTreatmentRequestResponse } from '../model';
// @ts-ignore
import { GetExportTreamentRequestsResponse } from '../model';
// @ts-ignore
import { GetExportTreatmentGraphResponse } from '../model';
// @ts-ignore
import { GetRecountTreamentRequestsResponse } from '../model';
// @ts-ignore
import { GetStatisticsResponse } from '../model';
// @ts-ignore
import { GetTreamentRequestsResponse } from '../model';
// @ts-ignore
import { GetTreatmentRequestCertificateResponse } from '../model';
// @ts-ignore
import { GetTreatmentRequestResponse } from '../model';
// @ts-ignore
import { PostTreamentRequestResponse } from '../model';
// @ts-ignore
import { PostTreatmentRequestRequest } from '../model';
// @ts-ignore
import { PutContinueTreamentRequestResponse } from '../model';
// @ts-ignore
import { PutContinueTreatmentRequestRequest } from '../model';
// @ts-ignore
import { PutStartTreamentRequestResponse } from '../model';
// @ts-ignore
import { PutStopTreamentRequestResponse } from '../model';
// @ts-ignore
import { PutStopTreatmentRequestRequest } from '../model';
// @ts-ignore
import { PutTreamentRequestResponse } from '../model';
// @ts-ignore
import { PutTreatmentRequestRequest } from '../model';
/**
 * TreatmentRequestsApi - axios parameter creator
 * @export
 */
export const TreatmentRequestsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} unitId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkRecount: async (unitId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'unitId' is not null or undefined
            assertParamExists('checkRecount', 'unitId', unitId)
            const localVarPath = `/api/treatment-requests/{unitId}/checkRecount`
                .replace(`{${"unitId"}}`, encodeURIComponent(String(unitId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkRedButton: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('checkRedButton', 'id', id)
            const localVarPath = `/api/treatment-requests/{id}/checkRedButton`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {PutContinueTreatmentRequestRequest} putContinueTreatmentRequestRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        continueTreatmentRequest: async (id: string, putContinueTreatmentRequestRequest: PutContinueTreatmentRequestRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('continueTreatmentRequest', 'id', id)
            // verify required parameter 'putContinueTreatmentRequestRequest' is not null or undefined
            assertParamExists('continueTreatmentRequest', 'putContinueTreatmentRequestRequest', putContinueTreatmentRequestRequest)
            const localVarPath = `/api/treatment-requests/{id}/continue`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(putContinueTreatmentRequestRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {PostTreatmentRequestRequest} postTreatmentRequestRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTreatmentRequest: async (postTreatmentRequestRequest: PostTreatmentRequestRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'postTreatmentRequestRequest' is not null or undefined
            assertParamExists('createTreatmentRequest', 'postTreatmentRequestRequest', postTreatmentRequestRequest)
            const localVarPath = `/api/treatment-requests`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(postTreatmentRequestRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTreatmentRequest: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteTreatmentRequest', 'id', id)
            const localVarPath = `/api/treatment-requests/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportTreatmentGraph: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('exportTreatmentGraph', 'id', id)
            const localVarPath = `/api/treatment-requests/{id}/export-graph`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [keyword] 
         * @param {string} [technique] 
         * @param {string} [status] 
         * @param {string} [startDate] 
         * @param {string} [endDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportTreatmentRequestsByKeyword: async (keyword?: string, technique?: string, status?: string, startDate?: string, endDate?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/treatment-requests/export`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (keyword !== undefined) {
                localVarQueryParameter['keyword'] = keyword;
            }

            if (technique !== undefined) {
                localVarQueryParameter['technique'] = technique;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['endDate'] = endDate;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTreatmentRequest: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getTreatmentRequest', 'id', id)
            const localVarPath = `/api/treatment-requests/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTreatmentRequestByLocation: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getTreatmentRequestByLocation', 'id', id)
            const localVarPath = `/api/treatment-requests/get-by-location/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [keyword] 
         * @param {string} [technique] 
         * @param {string} [status] 
         * @param {number} [limit] 
         * @param {number} [page] 
         * @param {string} [orderBy] 
         * @param {string} [orderDesc] 
         * @param {string} [startDate] 
         * @param {string} [endDate] 
         * @param {string} [treatmentType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTreatmentRequestsByKeyword: async (keyword?: string, technique?: string, status?: string, limit?: number, page?: number, orderBy?: string, orderDesc?: string, startDate?: string, endDate?: string, treatmentType?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/treatment-requests`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (keyword !== undefined) {
                localVarQueryParameter['keyword'] = keyword;
            }

            if (technique !== undefined) {
                localVarQueryParameter['technique'] = technique;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (orderBy !== undefined) {
                localVarQueryParameter['orderBy'] = orderBy;
            }

            if (orderDesc !== undefined) {
                localVarQueryParameter['orderDesc'] = orderDesc;
            }

            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['endDate'] = endDate;
            }

            if (treatmentType !== undefined) {
                localVarQueryParameter['treatmentType'] = treatmentType;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        startTreatmentRequest: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('startTreatmentRequest', 'id', id)
            const localVarPath = `/api/treatment-requests/{id}/start`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        statisticsDataTreatment: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/treatment-requests/statisticsData`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {PutStopTreatmentRequestRequest} putStopTreatmentRequestRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stopTreatmentRequest: async (id: string, putStopTreatmentRequestRequest: PutStopTreatmentRequestRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('stopTreatmentRequest', 'id', id)
            // verify required parameter 'putStopTreatmentRequestRequest' is not null or undefined
            assertParamExists('stopTreatmentRequest', 'putStopTreatmentRequestRequest', putStopTreatmentRequestRequest)
            const localVarPath = `/api/treatment-requests/{id}/stop`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(putStopTreatmentRequestRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {PutTreatmentRequestRequest} putTreatmentRequestRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTreatmentRequest: async (id: string, putTreatmentRequestRequest: PutTreatmentRequestRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateTreatmentRequest', 'id', id)
            // verify required parameter 'putTreatmentRequestRequest' is not null or undefined
            assertParamExists('updateTreatmentRequest', 'putTreatmentRequestRequest', putTreatmentRequestRequest)
            const localVarPath = `/api/treatment-requests/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(putTreatmentRequestRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        viewCertificateTreatmentRequest: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('viewCertificateTreatmentRequest', 'id', id)
            const localVarPath = `/api/treatment-requests/{id}/viewCertificate`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TreatmentRequestsApi - functional programming interface
 * @export
 */
export const TreatmentRequestsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TreatmentRequestsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} unitId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async checkRecount(unitId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetRecountTreamentRequestsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.checkRecount(unitId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async checkRedButton(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetRecountTreamentRequestsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.checkRedButton(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {PutContinueTreatmentRequestRequest} putContinueTreatmentRequestRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async continueTreatmentRequest(id: string, putContinueTreatmentRequestRequest: PutContinueTreatmentRequestRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PutContinueTreamentRequestResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.continueTreatmentRequest(id, putContinueTreatmentRequestRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {PostTreatmentRequestRequest} postTreatmentRequestRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createTreatmentRequest(postTreatmentRequestRequest: PostTreatmentRequestRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PostTreamentRequestResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createTreatmentRequest(postTreatmentRequestRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteTreatmentRequest(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DeleteTreatmentRequestResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteTreatmentRequest(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async exportTreatmentGraph(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetExportTreatmentGraphResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.exportTreatmentGraph(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [keyword] 
         * @param {string} [technique] 
         * @param {string} [status] 
         * @param {string} [startDate] 
         * @param {string} [endDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async exportTreatmentRequestsByKeyword(keyword?: string, technique?: string, status?: string, startDate?: string, endDate?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetExportTreamentRequestsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.exportTreatmentRequestsByKeyword(keyword, technique, status, startDate, endDate, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTreatmentRequest(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetTreatmentRequestResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTreatmentRequest(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTreatmentRequestByLocation(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetTreatmentRequestResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTreatmentRequestByLocation(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [keyword] 
         * @param {string} [technique] 
         * @param {string} [status] 
         * @param {number} [limit] 
         * @param {number} [page] 
         * @param {string} [orderBy] 
         * @param {string} [orderDesc] 
         * @param {string} [startDate] 
         * @param {string} [endDate] 
         * @param {string} [treatmentType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTreatmentRequestsByKeyword(keyword?: string, technique?: string, status?: string, limit?: number, page?: number, orderBy?: string, orderDesc?: string, startDate?: string, endDate?: string, treatmentType?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetTreamentRequestsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTreatmentRequestsByKeyword(keyword, technique, status, limit, page, orderBy, orderDesc, startDate, endDate, treatmentType, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async startTreatmentRequest(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PutStartTreamentRequestResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.startTreatmentRequest(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async statisticsDataTreatment(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetStatisticsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.statisticsDataTreatment(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {PutStopTreatmentRequestRequest} putStopTreatmentRequestRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async stopTreatmentRequest(id: string, putStopTreatmentRequestRequest: PutStopTreatmentRequestRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PutStopTreamentRequestResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.stopTreatmentRequest(id, putStopTreatmentRequestRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {PutTreatmentRequestRequest} putTreatmentRequestRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateTreatmentRequest(id: string, putTreatmentRequestRequest: PutTreatmentRequestRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PutTreamentRequestResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateTreatmentRequest(id, putTreatmentRequestRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async viewCertificateTreatmentRequest(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetTreatmentRequestCertificateResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.viewCertificateTreatmentRequest(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * TreatmentRequestsApi - factory interface
 * @export
 */
export const TreatmentRequestsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TreatmentRequestsApiFp(configuration)
    return {
        /**
         * 
         * @param {string} unitId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkRecount(unitId: string, options?: any): AxiosPromise<GetRecountTreamentRequestsResponse> {
            return localVarFp.checkRecount(unitId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkRedButton(id: string, options?: any): AxiosPromise<GetRecountTreamentRequestsResponse> {
            return localVarFp.checkRedButton(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {PutContinueTreatmentRequestRequest} putContinueTreatmentRequestRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        continueTreatmentRequest(id: string, putContinueTreatmentRequestRequest: PutContinueTreatmentRequestRequest, options?: any): AxiosPromise<PutContinueTreamentRequestResponse> {
            return localVarFp.continueTreatmentRequest(id, putContinueTreatmentRequestRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {PostTreatmentRequestRequest} postTreatmentRequestRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTreatmentRequest(postTreatmentRequestRequest: PostTreatmentRequestRequest, options?: any): AxiosPromise<PostTreamentRequestResponse> {
            return localVarFp.createTreatmentRequest(postTreatmentRequestRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTreatmentRequest(id: string, options?: any): AxiosPromise<DeleteTreatmentRequestResponse> {
            return localVarFp.deleteTreatmentRequest(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportTreatmentGraph(id: string, options?: any): AxiosPromise<GetExportTreatmentGraphResponse> {
            return localVarFp.exportTreatmentGraph(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [keyword] 
         * @param {string} [technique] 
         * @param {string} [status] 
         * @param {string} [startDate] 
         * @param {string} [endDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportTreatmentRequestsByKeyword(keyword?: string, technique?: string, status?: string, startDate?: string, endDate?: string, options?: any): AxiosPromise<GetExportTreamentRequestsResponse> {
            return localVarFp.exportTreatmentRequestsByKeyword(keyword, technique, status, startDate, endDate, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTreatmentRequest(id: string, options?: any): AxiosPromise<GetTreatmentRequestResponse> {
            return localVarFp.getTreatmentRequest(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTreatmentRequestByLocation(id: string, options?: any): AxiosPromise<GetTreatmentRequestResponse> {
            return localVarFp.getTreatmentRequestByLocation(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [keyword] 
         * @param {string} [technique] 
         * @param {string} [status] 
         * @param {number} [limit] 
         * @param {number} [page] 
         * @param {string} [orderBy] 
         * @param {string} [orderDesc] 
         * @param {string} [startDate] 
         * @param {string} [endDate] 
         * @param {string} [treatmentType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTreatmentRequestsByKeyword(keyword?: string, technique?: string, status?: string, limit?: number, page?: number, orderBy?: string, orderDesc?: string, startDate?: string, endDate?: string, treatmentType?: string, options?: any): AxiosPromise<GetTreamentRequestsResponse> {
            return localVarFp.getTreatmentRequestsByKeyword(keyword, technique, status, limit, page, orderBy, orderDesc, startDate, endDate, treatmentType, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        startTreatmentRequest(id: string, options?: any): AxiosPromise<PutStartTreamentRequestResponse> {
            return localVarFp.startTreatmentRequest(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        statisticsDataTreatment(options?: any): AxiosPromise<GetStatisticsResponse> {
            return localVarFp.statisticsDataTreatment(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {PutStopTreatmentRequestRequest} putStopTreatmentRequestRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stopTreatmentRequest(id: string, putStopTreatmentRequestRequest: PutStopTreatmentRequestRequest, options?: any): AxiosPromise<PutStopTreamentRequestResponse> {
            return localVarFp.stopTreatmentRequest(id, putStopTreatmentRequestRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {PutTreatmentRequestRequest} putTreatmentRequestRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTreatmentRequest(id: string, putTreatmentRequestRequest: PutTreatmentRequestRequest, options?: any): AxiosPromise<PutTreamentRequestResponse> {
            return localVarFp.updateTreatmentRequest(id, putTreatmentRequestRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        viewCertificateTreatmentRequest(id: string, options?: any): AxiosPromise<GetTreatmentRequestCertificateResponse> {
            return localVarFp.viewCertificateTreatmentRequest(id, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for checkRecount operation in TreatmentRequestsApi.
 * @export
 * @interface TreatmentRequestsApiCheckRecountRequest
 */
export interface TreatmentRequestsApiCheckRecountRequest {
    /**
     * 
     * @type {string}
     * @memberof TreatmentRequestsApiCheckRecount
     */
    readonly unitId: string
}

/**
 * Request parameters for checkRedButton operation in TreatmentRequestsApi.
 * @export
 * @interface TreatmentRequestsApiCheckRedButtonRequest
 */
export interface TreatmentRequestsApiCheckRedButtonRequest {
    /**
     * 
     * @type {string}
     * @memberof TreatmentRequestsApiCheckRedButton
     */
    readonly id: string
}

/**
 * Request parameters for continueTreatmentRequest operation in TreatmentRequestsApi.
 * @export
 * @interface TreatmentRequestsApiContinueTreatmentRequestRequest
 */
export interface TreatmentRequestsApiContinueTreatmentRequestRequest {
    /**
     * 
     * @type {string}
     * @memberof TreatmentRequestsApiContinueTreatmentRequest
     */
    readonly id: string

    /**
     * 
     * @type {PutContinueTreatmentRequestRequest}
     * @memberof TreatmentRequestsApiContinueTreatmentRequest
     */
    readonly putContinueTreatmentRequestRequest: PutContinueTreatmentRequestRequest
}

/**
 * Request parameters for createTreatmentRequest operation in TreatmentRequestsApi.
 * @export
 * @interface TreatmentRequestsApiCreateTreatmentRequestRequest
 */
export interface TreatmentRequestsApiCreateTreatmentRequestRequest {
    /**
     * 
     * @type {PostTreatmentRequestRequest}
     * @memberof TreatmentRequestsApiCreateTreatmentRequest
     */
    readonly postTreatmentRequestRequest: PostTreatmentRequestRequest
}

/**
 * Request parameters for deleteTreatmentRequest operation in TreatmentRequestsApi.
 * @export
 * @interface TreatmentRequestsApiDeleteTreatmentRequestRequest
 */
export interface TreatmentRequestsApiDeleteTreatmentRequestRequest {
    /**
     * 
     * @type {string}
     * @memberof TreatmentRequestsApiDeleteTreatmentRequest
     */
    readonly id: string
}

/**
 * Request parameters for exportTreatmentGraph operation in TreatmentRequestsApi.
 * @export
 * @interface TreatmentRequestsApiExportTreatmentGraphRequest
 */
export interface TreatmentRequestsApiExportTreatmentGraphRequest {
    /**
     * 
     * @type {string}
     * @memberof TreatmentRequestsApiExportTreatmentGraph
     */
    readonly id: string
}

/**
 * Request parameters for exportTreatmentRequestsByKeyword operation in TreatmentRequestsApi.
 * @export
 * @interface TreatmentRequestsApiExportTreatmentRequestsByKeywordRequest
 */
export interface TreatmentRequestsApiExportTreatmentRequestsByKeywordRequest {
    /**
     * 
     * @type {string}
     * @memberof TreatmentRequestsApiExportTreatmentRequestsByKeyword
     */
    readonly keyword?: string

    /**
     * 
     * @type {string}
     * @memberof TreatmentRequestsApiExportTreatmentRequestsByKeyword
     */
    readonly technique?: string

    /**
     * 
     * @type {string}
     * @memberof TreatmentRequestsApiExportTreatmentRequestsByKeyword
     */
    readonly status?: string

    /**
     * 
     * @type {string}
     * @memberof TreatmentRequestsApiExportTreatmentRequestsByKeyword
     */
    readonly startDate?: string

    /**
     * 
     * @type {string}
     * @memberof TreatmentRequestsApiExportTreatmentRequestsByKeyword
     */
    readonly endDate?: string
}

/**
 * Request parameters for getTreatmentRequest operation in TreatmentRequestsApi.
 * @export
 * @interface TreatmentRequestsApiGetTreatmentRequestRequest
 */
export interface TreatmentRequestsApiGetTreatmentRequestRequest {
    /**
     * 
     * @type {string}
     * @memberof TreatmentRequestsApiGetTreatmentRequest
     */
    readonly id: string
}

/**
 * Request parameters for getTreatmentRequestByLocation operation in TreatmentRequestsApi.
 * @export
 * @interface TreatmentRequestsApiGetTreatmentRequestByLocationRequest
 */
export interface TreatmentRequestsApiGetTreatmentRequestByLocationRequest {
    /**
     * 
     * @type {string}
     * @memberof TreatmentRequestsApiGetTreatmentRequestByLocation
     */
    readonly id: string
}

/**
 * Request parameters for getTreatmentRequestsByKeyword operation in TreatmentRequestsApi.
 * @export
 * @interface TreatmentRequestsApiGetTreatmentRequestsByKeywordRequest
 */
export interface TreatmentRequestsApiGetTreatmentRequestsByKeywordRequest {
    /**
     * 
     * @type {string}
     * @memberof TreatmentRequestsApiGetTreatmentRequestsByKeyword
     */
    readonly keyword?: string

    /**
     * 
     * @type {string}
     * @memberof TreatmentRequestsApiGetTreatmentRequestsByKeyword
     */
    readonly technique?: string

    /**
     * 
     * @type {string}
     * @memberof TreatmentRequestsApiGetTreatmentRequestsByKeyword
     */
    readonly status?: string

    /**
     * 
     * @type {number}
     * @memberof TreatmentRequestsApiGetTreatmentRequestsByKeyword
     */
    readonly limit?: number

    /**
     * 
     * @type {number}
     * @memberof TreatmentRequestsApiGetTreatmentRequestsByKeyword
     */
    readonly page?: number

    /**
     * 
     * @type {string}
     * @memberof TreatmentRequestsApiGetTreatmentRequestsByKeyword
     */
    readonly orderBy?: string

    /**
     * 
     * @type {string}
     * @memberof TreatmentRequestsApiGetTreatmentRequestsByKeyword
     */
    readonly orderDesc?: string

    /**
     * 
     * @type {string}
     * @memberof TreatmentRequestsApiGetTreatmentRequestsByKeyword
     */
    readonly startDate?: string

    /**
     * 
     * @type {string}
     * @memberof TreatmentRequestsApiGetTreatmentRequestsByKeyword
     */
    readonly endDate?: string

    /**
     * 
     * @type {string}
     * @memberof TreatmentRequestsApiGetTreatmentRequestsByKeyword
     */
    readonly treatmentType?: string
}

/**
 * Request parameters for startTreatmentRequest operation in TreatmentRequestsApi.
 * @export
 * @interface TreatmentRequestsApiStartTreatmentRequestRequest
 */
export interface TreatmentRequestsApiStartTreatmentRequestRequest {
    /**
     * 
     * @type {string}
     * @memberof TreatmentRequestsApiStartTreatmentRequest
     */
    readonly id: string
}

/**
 * Request parameters for stopTreatmentRequest operation in TreatmentRequestsApi.
 * @export
 * @interface TreatmentRequestsApiStopTreatmentRequestRequest
 */
export interface TreatmentRequestsApiStopTreatmentRequestRequest {
    /**
     * 
     * @type {string}
     * @memberof TreatmentRequestsApiStopTreatmentRequest
     */
    readonly id: string

    /**
     * 
     * @type {PutStopTreatmentRequestRequest}
     * @memberof TreatmentRequestsApiStopTreatmentRequest
     */
    readonly putStopTreatmentRequestRequest: PutStopTreatmentRequestRequest
}

/**
 * Request parameters for updateTreatmentRequest operation in TreatmentRequestsApi.
 * @export
 * @interface TreatmentRequestsApiUpdateTreatmentRequestRequest
 */
export interface TreatmentRequestsApiUpdateTreatmentRequestRequest {
    /**
     * 
     * @type {string}
     * @memberof TreatmentRequestsApiUpdateTreatmentRequest
     */
    readonly id: string

    /**
     * 
     * @type {PutTreatmentRequestRequest}
     * @memberof TreatmentRequestsApiUpdateTreatmentRequest
     */
    readonly putTreatmentRequestRequest: PutTreatmentRequestRequest
}

/**
 * Request parameters for viewCertificateTreatmentRequest operation in TreatmentRequestsApi.
 * @export
 * @interface TreatmentRequestsApiViewCertificateTreatmentRequestRequest
 */
export interface TreatmentRequestsApiViewCertificateTreatmentRequestRequest {
    /**
     * 
     * @type {string}
     * @memberof TreatmentRequestsApiViewCertificateTreatmentRequest
     */
    readonly id: string
}

/**
 * TreatmentRequestsApi - object-oriented interface
 * @export
 * @class TreatmentRequestsApi
 * @extends {BaseAPI}
 */
export class TreatmentRequestsApi extends BaseAPI {
    /**
     * 
     * @param {TreatmentRequestsApiCheckRecountRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TreatmentRequestsApi
     */
    public checkRecount(requestParameters: TreatmentRequestsApiCheckRecountRequest, options?: AxiosRequestConfig) {
        return TreatmentRequestsApiFp(this.configuration).checkRecount(requestParameters.unitId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {TreatmentRequestsApiCheckRedButtonRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TreatmentRequestsApi
     */
    public checkRedButton(requestParameters: TreatmentRequestsApiCheckRedButtonRequest, options?: AxiosRequestConfig) {
        return TreatmentRequestsApiFp(this.configuration).checkRedButton(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {TreatmentRequestsApiContinueTreatmentRequestRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TreatmentRequestsApi
     */
    public continueTreatmentRequest(requestParameters: TreatmentRequestsApiContinueTreatmentRequestRequest, options?: AxiosRequestConfig) {
        return TreatmentRequestsApiFp(this.configuration).continueTreatmentRequest(requestParameters.id, requestParameters.putContinueTreatmentRequestRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {TreatmentRequestsApiCreateTreatmentRequestRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TreatmentRequestsApi
     */
    public createTreatmentRequest(requestParameters: TreatmentRequestsApiCreateTreatmentRequestRequest, options?: AxiosRequestConfig) {
        return TreatmentRequestsApiFp(this.configuration).createTreatmentRequest(requestParameters.postTreatmentRequestRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {TreatmentRequestsApiDeleteTreatmentRequestRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TreatmentRequestsApi
     */
    public deleteTreatmentRequest(requestParameters: TreatmentRequestsApiDeleteTreatmentRequestRequest, options?: AxiosRequestConfig) {
        return TreatmentRequestsApiFp(this.configuration).deleteTreatmentRequest(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {TreatmentRequestsApiExportTreatmentGraphRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TreatmentRequestsApi
     */
    public exportTreatmentGraph(requestParameters: TreatmentRequestsApiExportTreatmentGraphRequest, options?: AxiosRequestConfig) {
        return TreatmentRequestsApiFp(this.configuration).exportTreatmentGraph(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {TreatmentRequestsApiExportTreatmentRequestsByKeywordRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TreatmentRequestsApi
     */
    public exportTreatmentRequestsByKeyword(requestParameters: TreatmentRequestsApiExportTreatmentRequestsByKeywordRequest = {}, options?: AxiosRequestConfig) {
        return TreatmentRequestsApiFp(this.configuration).exportTreatmentRequestsByKeyword(requestParameters.keyword, requestParameters.technique, requestParameters.status, requestParameters.startDate, requestParameters.endDate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {TreatmentRequestsApiGetTreatmentRequestRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TreatmentRequestsApi
     */
    public getTreatmentRequest(requestParameters: TreatmentRequestsApiGetTreatmentRequestRequest, options?: AxiosRequestConfig) {
        return TreatmentRequestsApiFp(this.configuration).getTreatmentRequest(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {TreatmentRequestsApiGetTreatmentRequestByLocationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TreatmentRequestsApi
     */
    public getTreatmentRequestByLocation(requestParameters: TreatmentRequestsApiGetTreatmentRequestByLocationRequest, options?: AxiosRequestConfig) {
        return TreatmentRequestsApiFp(this.configuration).getTreatmentRequestByLocation(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {TreatmentRequestsApiGetTreatmentRequestsByKeywordRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TreatmentRequestsApi
     */
    public getTreatmentRequestsByKeyword(requestParameters: TreatmentRequestsApiGetTreatmentRequestsByKeywordRequest = {}, options?: AxiosRequestConfig) {
        return TreatmentRequestsApiFp(this.configuration).getTreatmentRequestsByKeyword(requestParameters.keyword, requestParameters.technique, requestParameters.status, requestParameters.limit, requestParameters.page, requestParameters.orderBy, requestParameters.orderDesc, requestParameters.startDate, requestParameters.endDate, requestParameters.treatmentType, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {TreatmentRequestsApiStartTreatmentRequestRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TreatmentRequestsApi
     */
    public startTreatmentRequest(requestParameters: TreatmentRequestsApiStartTreatmentRequestRequest, options?: AxiosRequestConfig) {
        return TreatmentRequestsApiFp(this.configuration).startTreatmentRequest(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TreatmentRequestsApi
     */
    public statisticsDataTreatment(options?: AxiosRequestConfig) {
        return TreatmentRequestsApiFp(this.configuration).statisticsDataTreatment(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {TreatmentRequestsApiStopTreatmentRequestRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TreatmentRequestsApi
     */
    public stopTreatmentRequest(requestParameters: TreatmentRequestsApiStopTreatmentRequestRequest, options?: AxiosRequestConfig) {
        return TreatmentRequestsApiFp(this.configuration).stopTreatmentRequest(requestParameters.id, requestParameters.putStopTreatmentRequestRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {TreatmentRequestsApiUpdateTreatmentRequestRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TreatmentRequestsApi
     */
    public updateTreatmentRequest(requestParameters: TreatmentRequestsApiUpdateTreatmentRequestRequest, options?: AxiosRequestConfig) {
        return TreatmentRequestsApiFp(this.configuration).updateTreatmentRequest(requestParameters.id, requestParameters.putTreatmentRequestRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {TreatmentRequestsApiViewCertificateTreatmentRequestRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TreatmentRequestsApi
     */
    public viewCertificateTreatmentRequest(requestParameters: TreatmentRequestsApiViewCertificateTreatmentRequestRequest, options?: AxiosRequestConfig) {
        return TreatmentRequestsApiFp(this.configuration).viewCertificateTreatmentRequest(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }
}
